import { relativeTime } from "./useHelperStatus";
import type { HelperStatus } from "./useHelperStatus";

function SchedulerCard() {
  return (
    <div className="sc-item-row">
      <div>
        <div className="sc-item-name">Scheduler</div>
        <div className="sc-item-meta">Managed by Relay — always on</div>
      </div>
    </div>
  );
}

interface SystemTeamSectionProps {
  workspaceId: string;
  /** Relay Helper status, owned by TeamPage so every place on the page agrees. */
  helper: HelperStatus;
}

export function SystemTeamSection({ helper }: SystemTeamSectionProps) {
  const rel = relativeTime(helper.lastHeartbeat);

  function jumpToHelper(e: React.MouseEvent) {
    e.preventDefault();
    document.getElementById("team-section-helper")?.scrollIntoView?.({ behavior: "smooth" });
  }

  return (
    <section id="team-section-system" className="tp-group">
      <div className="tp-group-head"><div className="tp-card-title">System</div></div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <SchedulerCard />

        <div className="sc-item-row">
          <div>
            <div className="sc-item-name" style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <span className={`tp-dot${helper.online ? "" : " off"}`} />
              Relay Helper
              <span className="tp-small">· <a href="#team-section-helper" onClick={jumpToHelper}>details</a></span>
            </div>
            <div className="sc-item-meta">
              {helper.online
                ? rel ? `Running · last check-in ${rel}` : "Running"
                : "Relay Helper is offline. Open Relay Helper and click Start."}
            </div>
          </div>
          <span className={`tp-badge${helper.online ? "" : " off"}`}>{helper.online ? "Running" : "Offline"}</span>
        </div>
      </div>
    </section>
  );
}
